import {
  FeaturedProjects,
  Hero,
  Leadership,
  Services,
  StatsBar,
  TrustedBy,
  WhyChooseUs,
} from "@/components";

export const HomePage = () => {
  return (
    <main>
      <Hero />
      <StatsBar />
      <WhyChooseUs />
      <Services />
      <FeaturedProjects />
      {/* <TechnicalCapabilities /> */}
      <TrustedBy />
      <Leadership />
    </main>
  );
};
